import React from 'react';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../store/slices/authSlice';
import companyReducer from '../store/slices/companySlice';
import weighingReducer from '../store/slices/weighingSlice';
import userReducer from '../store/slices/userSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    company: companyReducer,
    weighing: weighingReducer,
    user: userReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const StoreProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <Provider store={store}>{children}</Provider>;
};